/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".img-container[_ngcontent-%COMP%], [_nghost-%COMP%]{position:relative}.img-container[_ngcontent-%COMP%]:after{position:absolute;top:0;left:0;content:\"\";width:100%;height:100%;background:rgba(0,0,0,.5);border-radius:4px;overflow:hidden}.genre-name[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-transform:capitalize;font-size:2rem;color:var(--be-accent-contrast);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}"];
export { styles as styles };
